/* eslint-disable no-extend-native */
import ReactDOM from 'react-dom/client';
import App from './App';

import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from 'reportWebVitals';

console.log('script start');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
console.log('root found');

root.render(
  <>
    {/* <div>env = {process.env.NODE_ENV}</div> */}
    {/* <React.StrictMode> */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
    {/* </React.StrictMode> */}
  </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
